import type { FC, ReactElement, ReactNode } from "react";
import { useEffect, useState } from "react";

import { Dropdown } from "@similarweb/ui-components";

import "app/components/React/UserSettingDropdown/UserSettingsDropdown.scss";

import "./OnboardingHubDropdown.scss";

import { StyledOnboardingHubButtonWrapper } from "./styles";

interface Props {
    isLoading: boolean;
    renderButton: (isButtonActive: boolean) => ReactElement;
    content: Array<ReactNode>;
    dropdownRef?: React.RefObject<any>;
    onToggleHub: (isOpen: boolean) => void;
}

const OnboardingHubDropdown: FC<Props> = ({ renderButton, onToggleHub, isLoading, content, dropdownRef }) => {
    const [isDropdownOpened, setIsDropdownOpened] = useState(false);

    useEffect(() => {
        onToggleHub(false);
    }, []);

    return (
        <Dropdown
            disabled={isLoading}
            ref={dropdownRef}
            width={392}
            dropdownPopupHeight={706}
            buttonWidth="auto"
            appendTo="body"
            dropdownPopupPlacement="right"
            closeOnItemClick={false}
            cssClassContainer="DropdownContent-container OnboardingHubDropdown-container"
            onToggle={(isOpen) => {
                onToggleHub(isOpen);
                setIsDropdownOpened(isOpen);
            }}
        >
            {[
                <StyledOnboardingHubButtonWrapper key="OnboardingHubButtonWrapper">
                    {renderButton(isDropdownOpened)}
                </StyledOnboardingHubButtonWrapper>,
                ...content,
            ]}
        </Dropdown>
    );
};

export default OnboardingHubDropdown;
